import moment from 'moment'
export const IMAGE_TYPES = {
  IMAGE: 1,
  VIDEO: 2,
  LOGO: 4,
  STICKERS: 5,
  AUDIO: 6,
  GROUP_IMAGE: 8,
  META: 9,
  AI_REMIX: -10,
  REMIX_AUDIT_PRE: 11, // 混剪视频待审核
  REMIX_AUDIT_DENY: 12, // 混剪视频审核不通过
  REMIX_AUDIT_PASS: 13, // 混剪视频审核通过
  PLAYABLE: 14, // 试玩素材
  SHOT: 18 // 分镜切片
}
const STRING_VALUE = {}

for (const key in IMAGE_TYPES) {
  STRING_VALUE[key] = String(IMAGE_TYPES[key])
}
export const IMAGE_TYPES_STR_VAL = STRING_VALUE

export const IMAGE_COUNT = {
  SINGLE: 1,
  GROUP: 2
}

/**
 * @description: 素材样式
 * @return {*}
 */
export const IMAGE_STYLE = {
  GRAPHIC: 1316,
  TWOD: 1317,
  TWOFIVED: 1318,
  THREED: 1319,
  HUMAN: 1322,
  AI: 1323
}

export const IMAGE_STYLE_LIST = [
  {
    label: '平面',
    value: IMAGE_STYLE.GRAPHIC
  },
  {
    label: '2D',
    value: IMAGE_STYLE.TWOD
  },
  {
    label: '2.5D',
    value: IMAGE_STYLE.TWOFIVED
  },
  {
    label: '3D',
    value: IMAGE_STYLE.THREED
  },
  {
    label: '真人',
    value: IMAGE_STYLE.HUMAN
  },
  {
    label: 'AI',
    value: IMAGE_STYLE.AI
  }
]

/**
 * @description: 组图类型
 * @return {*}
 */
export const GROUP_IMAGE_TYPE = {
  IMG_THREE_1_1: 1,
  IMG_THREE_3_2: 2,
  IMG_FOUR_1_1: 3,
  IMG_SIX_1_1: 4,
  IMG_NINE_1_1: 5
}
export const GROUP_IMAGE_TYPE_LIST = [
  {
    label: '3图（1:1）',
    value: GROUP_IMAGE_TYPE.IMG_THREE_1_1,
    imageCount: 3
  },
  {
    label: '3图（3:2）',
    value: GROUP_IMAGE_TYPE.IMG_THREE_3_2,
    imageCount: 3
  },
  {
    label: '4图（1:1）',
    value: GROUP_IMAGE_TYPE.IMG_FOUR_1_1,
    imageCount: 4
  },
  {
    label: '6图（1:1）',
    value: GROUP_IMAGE_TYPE.IMG_SIX_1_1,
    imageCount: 6
  },
  {
    label: '9图（1:1）',
    value: GROUP_IMAGE_TYPE.IMG_NINE_1_1,
    imageCount: 9
  }
]

/**
 * @description: 素材上传类型
 * @return {*}
 */
export const UPLOAD_TYPE = {
  NEW: 1,
  LEGACY: 2
}

export const IMAGE_TYPES_LIST = [
  {
    type: IMAGE_TYPES.VIDEO,
    label: '视频'
  },
  {
    type: IMAGE_TYPES.IMAGE,
    label: '图片'
  },
  {
    type: IMAGE_TYPES.GROUP_IMAGE,
    label: '组图'
  },
  {
    type: IMAGE_TYPES.PLAYABLE,
    label: '试玩'
  },
  {
    type: IMAGE_TYPES.META,
    label: '元视频'
  },
  {
    type: IMAGE_TYPES.LOGO,
    label: 'LOGO'
  },
  {
    type: IMAGE_TYPES.STICKERS,
    label: '贴纸'
  },
  {
    type: IMAGE_TYPES.AUDIO,
    label: '音频'
  }
]

export const getUploadFormDefaultFields = () => {
  return {
    lauchTime: moment().format('YYYY-MM-DD'),
    imageType: IMAGE_TYPES.VIDEO,
    uploadType: 1,
    bindMaterId: 0,
    bindMaterName: '',
    videoProcess: false,
    videoLabelIds: [],
    subtitleEnable: true,
    aiAuditEnabled: false,
    aiLabelEnable: false,
    aiStrategyIds: [],
    playableMaterialName: '',
    gdtPlayableId: '',
    group: [],
    plannerId: '',
    game: [],
    label: [], // 标签
    labelGroup: [], // 标签组
    typeLabelIds: [],
    imageCount: 1, // 图片类型 单图 多图
    imageStyles: [],
    excludeMediaSwitch: false,
    excludeMediaIds: [10, 16, 32, 45],
    source: 1,
    overseas: false
  }
}

/**
 * @description: 素材ai审核状态枚举
 * @return {*}
 */
export const AI_MARTERIAL_AUDIT_STATES_ENUM = {
  UNSTARTED: 0,
  RUNNING: 1,
  AUDITING: 2,
  AUDIT_PASSED: 3,
  AUDIT_REJECTED: 4,
  FAILED: 5
}

/**
 * @description: 素材ai分析状态枚举
 * @return {*}
 */
export const AI_MARTERIAL_ANALYSIS_STATES_ENUM = {
  UNANALYZED: 0,
  ANALYZING: 1,
  ANALYSIS_PASSED: 3,
  ANALYSIS_FAILED: 5
}

/**
 * @description: 素材ai评估状态枚举
 * @return {*}
 */
export const AI_MARTERIAL_ESTIMATE_STATES_ENUM = {
  UNESTIMATED: 0,
  ESTIMATING: 1,
  ESTIMATION_PASSED: 3,
  ESTIMATION_FAILED: 5
}

export const AI_ANALYSIS_LIST = [
  { id: AI_MARTERIAL_ANALYSIS_STATES_ENUM.UNANALYZED, name: '未解析' },
  { id: AI_MARTERIAL_ANALYSIS_STATES_ENUM.ANALYZING, name: '解析中' },
  { id: AI_MARTERIAL_ANALYSIS_STATES_ENUM.ANALYSIS_PASSED, name: '解析成功' },
  { id: AI_MARTERIAL_ANALYSIS_STATES_ENUM.ANALYSIS_FAILED, name: '解析失败' }
]

export const AI_AUDIT_LIST = [
  { id: AI_MARTERIAL_AUDIT_STATES_ENUM.RUNNING, name: '处理中' },
  { id: AI_MARTERIAL_AUDIT_STATES_ENUM.AUDITING, name: '待确认' },
  { id: AI_MARTERIAL_AUDIT_STATES_ENUM.AUDIT_PASSED, name: '审核通过' },
  { id: AI_MARTERIAL_AUDIT_STATES_ENUM.AUDIT_REJECTED, name: '审核拒绝' },
  { id: AI_MARTERIAL_AUDIT_STATES_ENUM.FAILED, name: '执行失败' }
]

export const AI_ESTIMATE_LIST = [
  { id: AI_MARTERIAL_ESTIMATE_STATES_ENUM.UNESTIMATED, name: '未评估' },
  { id: AI_MARTERIAL_ESTIMATE_STATES_ENUM.ESTIMATING, name: '评估中' },
  { id: AI_MARTERIAL_ESTIMATE_STATES_ENUM.ESTIMATION_PASSED, name: '评估成功' },
  { id: AI_MARTERIAL_ESTIMATE_STATES_ENUM.ESTIMATION_FAILED, name: '评估失败' }
]

export const TASK_TYPE_LIST = [
  { id: 1, name: '人工上传' },
  { id: 5, name: 'A/B混剪' },
  { id: 6, name: '脚本混剪' }
]

export const MATERIAL_TYPE_LIST = [
  { id: IMAGE_TYPES.META, name: '元视频' },
  { id: IMAGE_TYPES.VIDEO, name: '视频' }
]
